import { Button, Collapse, Form, Layout } from "antd";
import styled from "styled-components";

const { Content } = Layout;

export const Container = styled.div`
  padding: 16px;
`;

export const AddButton = styled(Button)`
  padding: 18px;
  border-radius: 3px;
  box-shadow: none;
`;

export const Header = styled.div`
  font-family: "Poppins", sans-serif;
  margin: 0 0 16px 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const H2 = styled.h2`
  margin: 0;
  font-size: 22px;
  font-weight: 300;
`;

export const Span = styled.span`
  font-size: 12px;
`;

export const FooterButtons = styled.div`
  display: flex;
  width: 100%;
  justify-content: end;
  gap: 8px;

  button {
    min-width: 100px;
  }
`;

export const OperationCol = styled.div`
  display: flex;
  gap: 12px;
`;

export const StyledLayout = styled(Layout)`
  height: calc(100vh - 40px);

  @media (max-width: 820px) {
    background-color: #ffffff;
  }
`;

export const StyledContent = styled(Content)`
  padding: 16px;
  display: flex;
  height: calc(100dvh - 100px);
  overflow-y: auto;
  overflow-x: hidden;
  gap: 16px;
`;

export const StyledColumn = styled.div`
  flex: 1;
  background-color: #fff;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  width: 33.33%;
`;

export const StyledHeader = styled.div`
  padding: 16px;
  background-color: #f5f5f5;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #f0f0f0;
  font-weight: bold;

  @media (max-width: 820px) {
    background-color: #f0f0f0;
  }
`;

export const StyledFooter = styled.div`
  padding: 16px;
  background-color: #f5f5f5;
  border-top: 1px solid #f0f0f0;
  display: flex;
  justify-content: center;
`;

export const StyledBody = styled.div`
  padding: 16px;
  flex: 1;
  overflow-y: auto;
`;

export const SelectedItem = styled.div<{ isSelected: boolean }>`
  background-color: ${(props) => (props.isSelected ? "#e6f7ff" : "transparent")};
  cursor: pointer;
  border-radius: 4px;
  padding: 4px;

  &:hover {
    background-color: #f0f0f0;
  }

  & .ant-list-item .ant-list-item-action {
    margin-inline-start: 0px;
  }
`;

export const ItemNameText = styled.span`
  width: calc(100% - 38px);
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
`;

export const ItemListNameWrapper = styled.div`
  width: calc(100% - 132px);
`;
export const ItemNameWrapper = styled.div`
  &.bold {
    font-weight: bold;
  }
  display: flex;
  align-items: center;
  gap: 10px;
  text-align: center;
`;

export const WebView = styled.div`
  display: block;
  @media (max-width: 820px) {
    display: none;
  }
`;

export const MobileView = styled.div`
  display: none;
  margin-top: 20px;

  .ant-collapse-header {
    padding: 0 24px !important;
  }
  .ant-layout {
    background-color: #fff !important;
  }

  .ant-collapse-expand-icon {
    height: 75px !important;
  }

  @media (max-width: 820px) {
    display: block;
    background-color: #f0f0f0 !important;

    .ant-collapse {
      background-color: #f0f0f0;
    }
  }
`;

export const AddConditionalStyledButton = styled(Button)`
  border-radius: 4px;
  width: 100%;
  padding: 18px;
  border: 1px solid #154075;
  background: #154075;
  height: 40px;
  min-width: 270px;
`;

export const StyledCollapse = styled(Collapse)`
  border: 1px solid #154075 !important;
  background: #f3f8ff !important;

  .ant-collapse-item {
    background: #154075;

    .ant-collapse-header {
      padding: 8px !important;
      text-align: center !important;
      color: #fff !important;
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
      display: flex;
      align-items: center;
      gap: 16px;
    }

    .ant-collapse-content-box {
      padding: 0px 16px !important;
      background: #f3f8ff !important;
    }
  }
`;

export const StyledTypography = styled.div`
  color: #000;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-bottom: 8px;
`;

export const StyledOptionContainer = styled.div`
  display: flex;
  padding: 8px 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  align-self: stretch;
  border: 1px solid #154075;
  background: #f3f8ff;
`;

export const StyledOptionWrapper = styled.div`
  display: flex;
  height: 64px;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  flex-wrap: wrap;
  justify-content: space-between;
`;

export const AddAnotherConditionalStyledButton = styled(Button)`
  display: flex;
  padding: 16px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  border-radius: 100px;
  border: 1px dashed #154075 !important;
  background: #f3f8ff !important;
  color: #154075 !important;
  width: 100%;
`;

export const AddFieldWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  align-self: stretch;
`;

export const StyledConditionalContainer = styled.div`
  display: flex;
  padding: 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  align-self: stretch;
  border: 1px solid #154075;
  background: #fff;
`;

export const StyledConditionalRemoveButton = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  color: #154075 !important;
  font-weight: 700;
  cursor: pointer;
`;

export const StyledIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 14px;
  height: 14px;
  aspect-ratio: 1/1;
`;
